var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndermaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1330,
    height: 423,
    viewBox: "0 0 1330 423",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2881 121.525C36.4626 121.202 36.8005 121 37.1681 121H105.411C106.147 121 106.631 121.769 106.313 122.433L94.3198 147.433C94.1535 147.779 93.8029 148 93.4182 148H23.676C22.9189 148 22.4364 147.191 22.796 146.525L36.2881 121.525Z",
    fill: "#007AE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.288 121.525C131.463 121.202 131.801 121 132.168 121H200.411C201.147 121 201.631 121.769 201.313 122.433L189.32 147.433C189.153 147.779 188.803 148 188.418 148H118.676C117.919 148 117.436 147.191 117.796 146.525L131.288 121.525Z",
    fill: "#007AE8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M226.288 121.525C226.463 121.202 226.801 121 227.168 121H295.411C296.147 121 296.631 121.769 296.313 122.433L284.32 147.433C284.153 147.779 283.803 148 283.418 148H213.676C212.919 148 212.436 147.191 212.796 146.525L226.288 121.525Z",
    fill: "#007AE8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M321.288 121.525C321.463 121.202 321.801 121 322.168 121H390.411C391.147 121 391.631 121.769 391.313 122.433L379.32 147.433C379.153 147.779 378.803 148 378.418 148H308.676C307.919 148 307.436 147.191 307.796 146.525L321.288 121.525Z",
    fill: "#007AE8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M851.288 121.525C851.463 121.202 851.801 121 852.168 121H920.411C921.147 121 921.631 121.769 921.313 122.433L909.32 147.433C909.153 147.779 908.803 148 908.418 148H838.676C837.919 148 837.436 147.191 837.796 146.525L851.288 121.525Z",
    fill: "url(#paint0_linear_1930_402)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M946.288 121.525C946.463 121.202 946.801 121 947.168 121H1015.41C1016.15 121 1016.63 121.769 1016.31 122.433L1004.32 147.433C1004.15 147.779 1003.8 148 1003.42 148H933.676C932.919 148 932.436 147.191 932.796 146.525L946.288 121.525Z",
    fill: "url(#paint1_linear_1930_402)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1041.29 121.525C1041.46 121.202 1041.8 121 1042.17 121H1110.41C1111.15 121 1111.63 121.769 1111.31 122.433L1099.32 147.433C1099.15 147.779 1098.8 148 1098.42 148H1028.68C1027.92 148 1027.44 147.191 1027.8 146.525L1041.29 121.525Z",
    fill: "url(#paint2_linear_1930_402)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 121.525C1136.46 121.202 1136.8 121 1137.17 121H1205.41C1206.15 121 1206.63 121.769 1206.31 122.433L1194.32 147.433C1194.15 147.779 1193.8 148 1193.42 148H1123.68C1122.92 148 1122.44 147.191 1122.8 146.525L1136.29 121.525Z",
    fill: "url(#paint3_linear_1930_402)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.29 121.525C1231.46 121.202 1231.8 121 1232.17 121H1300.41C1301.15 121 1301.63 121.769 1301.31 122.433L1289.32 147.433C1289.15 147.779 1288.8 148 1288.42 148H1218.68C1217.92 148 1217.44 147.191 1217.8 146.525L1231.29 121.525Z",
    fill: "url(#paint4_linear_1930_402)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M656.67 7.49999C658.594 4.16666 663.406 4.16667 665.33 7.5L772.717 193.5C774.642 196.833 772.236 201 768.387 201H553.613C549.764 201 547.358 196.833 549.283 193.5L656.67 7.49999Z",
    fill: "#007AE8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M670.289 85.8L668.369 143.76H654.209L652.169 85.8H670.289ZM661.649 171.84C658.609 171.84 656.089 170.92 654.089 169.08C652.169 167.16 651.209 164.8 651.209 162C651.209 159.2 652.169 156.88 654.089 155.04C656.089 153.12 658.609 152.16 661.649 152.16C664.609 152.16 667.049 153.12 668.969 155.04C670.889 156.88 671.849 159.2 671.849 162C671.849 164.8 670.889 167.16 668.969 169.08C667.049 170.92 664.609 171.84 661.649 171.84Z",
    fill: "#2C2727"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M421.288 121.525C421.463 121.202 421.801 121 422.168 121H490.411C491.147 121 491.631 121.769 491.313 122.433L479.32 147.433C479.153 147.779 478.803 148 478.418 148H408.676C407.919 148 407.436 147.191 407.796 146.525L421.288 121.525Z",
    fill: "#007AE8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1930_402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2891 336.866C36.4711 337.025 36.7044 337.112 36.9459 337.112H104.551C105.447 337.112 105.891 336.025 105.251 335.398L94.3392 324.704C94.1523 324.521 93.901 324.418 93.6393 324.418H24.6703C23.7458 324.418 23.3164 325.565 24.0134 326.172L36.2891 336.866Z",
    fill: "#007AE8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.289 336.866C131.471 337.025 131.704 337.112 131.946 337.112H199.551C200.447 337.112 200.891 336.025 200.251 335.398L189.339 324.704C189.152 324.521 188.901 324.418 188.639 324.418H119.67C118.746 324.418 118.316 325.565 119.013 326.172L131.289 336.866Z",
    fill: "#007AE8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.289 336.866C226.471 337.025 226.704 337.112 226.946 337.112H294.551C295.447 337.112 295.891 336.025 295.251 335.398L284.339 324.704C284.152 324.521 283.901 324.418 283.639 324.418H214.67C213.746 324.418 213.316 325.565 214.013 326.172L226.289 336.866Z",
    fill: "#007AE8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.289 336.866C321.471 337.025 321.704 337.112 321.946 337.112H389.551C390.447 337.112 390.891 336.025 390.251 335.398L379.339 324.704C379.152 324.521 378.901 324.418 378.639 324.418H309.67C308.746 324.418 308.316 325.565 309.013 326.172L321.289 336.866Z",
    fill: "#007AE8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.289 336.866C851.471 337.025 851.704 337.112 851.946 337.112H919.551C920.447 337.112 920.891 336.025 920.251 335.398L909.339 324.704C909.152 324.521 908.901 324.418 908.639 324.418H839.67C838.746 324.418 838.316 325.565 839.013 326.172L851.289 336.866Z",
    fill: "url(#paint5_linear_1930_402)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.289 336.866C946.471 337.025 946.704 337.112 946.946 337.112H1014.55C1015.45 337.112 1015.89 336.025 1015.25 335.398L1004.34 324.704C1004.15 324.521 1003.9 324.418 1003.64 324.418H934.67C933.746 324.418 933.316 325.565 934.013 326.172L946.289 336.866Z",
    fill: "url(#paint6_linear_1930_402)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.29 336.866C1041.47 337.025 1041.7 337.112 1041.95 337.112H1109.55C1110.45 337.112 1110.89 336.025 1110.25 335.398L1099.34 324.704C1099.15 324.521 1098.9 324.418 1098.64 324.418H1029.67C1028.75 324.418 1028.32 325.565 1029.01 326.172L1041.29 336.866Z",
    fill: "url(#paint7_linear_1930_402)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136.29 336.866C1136.47 337.025 1136.7 337.112 1136.95 337.112H1204.55C1205.45 337.112 1205.89 336.025 1205.25 335.398L1194.34 324.704C1194.15 324.521 1193.9 324.418 1193.64 324.418H1124.67C1123.75 324.418 1123.32 325.565 1124.01 326.172L1136.29 336.866Z",
    fill: "url(#paint8_linear_1930_402)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.29 336.866C1231.47 337.025 1231.7 337.112 1231.95 337.112H1299.55C1300.45 337.112 1300.89 336.025 1300.25 335.398L1289.34 324.704C1289.15 324.521 1288.9 324.418 1288.64 324.418H1219.67C1218.75 324.418 1218.32 325.565 1219.01 326.172L1231.29 336.866Z",
    fill: "url(#paint9_linear_1930_402)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.843 391.429C659.681 392.926 662.319 392.926 664.157 391.429L766.146 308.377C769.794 305.406 767.694 299.5 762.989 299.5H559.011C554.306 299.5 552.206 305.406 555.854 308.377L657.843 391.429Z",
    fill: "#007AE8",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.748 354.382L684.82 326.368H677.976L676.99 354.382H685.748ZM681.572 312.796C680.103 312.796 678.885 313.24 677.918 314.13C676.99 315.058 676.526 316.198 676.526 317.552C676.526 318.905 676.99 320.026 677.918 320.916C678.885 321.844 680.103 322.308 681.572 322.308C683.003 322.308 684.182 321.844 685.11 320.916C686.038 320.026 686.502 318.905 686.502 317.552C686.502 316.198 686.038 315.058 685.11 314.13C684.182 313.24 683.003 312.796 681.572 312.796Z",
    fill: "#2C2727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.289 336.866C421.471 337.025 421.704 337.112 421.946 337.112H489.551C490.447 337.112 490.891 336.025 490.251 335.398L479.339 324.704C479.152 324.521 478.901 324.418 478.639 324.418H409.67C408.746 324.418 408.316 325.565 409.013 326.172L421.289 336.866Z",
    fill: "#007AE8",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1930_402",
    x: 0.667969,
    y: 277.5,
    width: 1328.89,
    height: 145.052,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1930_402"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1930_402",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1930_402",
    x1: 837,
    y1: 134.5,
    x2: 922,
    y2: 134.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0789996,
    stopColor: "#007AE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#01E4D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1930_402",
    x1: 932,
    y1: 134.5,
    x2: 1017,
    y2: 134.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007AE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#01E4D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1930_402",
    x1: 1027,
    y1: 134.5,
    x2: 1112,
    y2: 134.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007AE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#01E4D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1930_402",
    x1: 1122,
    y1: 134.5,
    x2: 1207,
    y2: 134.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007AE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#01E4D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1930_402",
    x1: 1217,
    y1: 134.5,
    x2: 1302,
    y2: 134.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007AE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#01E4D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1930_402",
    x1: 837,
    y1: 330.765,
    x2: 922,
    y2: 330.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0789996,
    stopColor: "#007AE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#01E4D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1930_402",
    x1: 932,
    y1: 330.765,
    x2: 1017,
    y2: 330.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007AE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#01E4D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1930_402",
    x1: 1027,
    y1: 330.765,
    x2: 1112,
    y2: 330.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007AE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#01E4D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1930_402",
    x1: 1122,
    y1: 330.765,
    x2: 1207,
    y2: 330.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007AE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#01E4D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1930_402",
    x1: 1217,
    y1: 330.765,
    x2: 1302,
    y2: 330.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007AE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#01E4D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndermaintenance);
export default __webpack_public_path__ + "static/media/under maintenance.8d677cf06f6cda5f0472ad18fc1cceff.svg";
export { ForwardRef as ReactComponent };